// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vx-simple-table:not(.vx-simple-table--hoverable) tbody tr:hover{background-color:transparent!important}.vx-simple-table thead tr{text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
